import { appMethod as app } from '@utils/app';
import { getCurrentPageQueryParams, convertLineStyleData } from '@utils/tools';
import { TopNav } from '@common/top-nav/TopNav';
import OfficialPage from '../OfficialPage';

import './GoodsOrderDetail.less'

export default class GoodsOrderDetail extends OfficialPage {
  state = {
    orderInfo: {},
    orderStatus: {
      '0': '订单待付款',
      '1': '商家待发货',
      '2': '买家待收货',
      '3': '订单待评价',
      '4': '退款审核中',
      '5': '退款中',
      '6': '订单已完成',
      '7': '已关闭',
      '8': '卖家待接单',
      '15': '退款失败'
    },
    orderIcon: {
      '0': 'goods-undone-payment',
      '1': 'goods-undone-ship',
      '2': 'goods-undone-receipt',
      '3': 'goods-undone-evaluation',
      '4': 'goods-refund',
      '5': 'goods-refund-doing',
      '6': 'goods-order-complete',
      '7': 'goods-order-close'
    },
    refundStatus: [
      '退款审核中',
      '',
      '',
      '等待买家退货',
      '商家待收货',
      '',
      '等待第三方退款结果'
    ],
    refundIcon: [
      'goods-refund-review',
      '',
      '',
      'goods-refund',
      'goods-undone-receipt',
      '',
      'goods-already-refund'
    ],
    refundReason: [
      '多拍/拍错/不想要',
      '快递延期',
      '未按约定时间发货',
      '快递记录出错',
      '内容与描述不符',
      '其它'
    ],
    goodsAdditionalInfo: {},
    hasAdditionalInfo: false,
    customFields: [],
    orderId: '',
    isFromTemplateMsg: false,
    originalPrice: '',
    useBalance: '',
    freightAdress: {},
    express_fee: '',
    discount_cut_price: '',
    isFromBack: false,
    showWriteOffCodeBox: false,
    showEventDialog: false,
    eventType: '',
    hasAlreadyGoods: false,
    sameCityStatus: {
      101: '配送中-待骑手接单',
      102: '配送中-待骑手取货',
      201: '配送中-待骑手取货',
      202: '配送中-待送达',
      301: '配送中-待送达',
      304: '订单配送失败，物品返回中',
      305: '订单拒收，物品返回中',
      401: '商品返还商户，等待重新配送',
      501: '订单异常',
      502: '订单异常'
    },
    sameCity: false,
    mapOverlay: {
      latitude: 22.52,
      longitude: 113.93,
      markers: []
    },
    storeStyle: {}
  }
  verifiTimeInterval = ''
  downcountArr = []
  
  constructor(props) {
    super(props);
    document.title = '订单详情';
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    this.setData({
      orderId: options.detail,
      isFromTemplateMsg: options.from === 'template_msg' ? true : false,
      sessionFrom: options.franchisee || app.getAppId() || ''
    })
    this.franchiseeId = options.franchisee || ''
    this.dataInitial()
  }

  componentDidMount() {
    if (this.data.isFromBack) {
      if (!!this.data.orderInfo.order_id) {
        this.getOrderDetail(this.data.orderInfo.order_id)
      }
    } else {
      this.setData({
        isFromBack: true
      })
    }
  }

  componentWillUnmount() {
    if (this.downcountArr && this.downcountArr.length) {
      this.downcountArr = this.downcountArr.concat().reverse()
      for (let i = 0; i < this.downcountArr.length; i++) {
        this.downcountArr[i] && this.downcountArr[i].clear()
      }
    }
  }

  dataInitial = () => {
    this.getOrderDetail(this.data.orderId)
    this.getLogistics()
    this.getAppECStoreConfig()
    this.setData({
      appName: app.globalData.appTitle,
      appLogo: app.globalData.appLogo
    })
  }
  getOrderDetail = orderId => {
    var that = this
    app.getOrderDetail({
      data: {
        order_id: orderId,
        sub_shop_app_id: this.franchiseeId
      },
      success: function (res) {
        var data = res.data[0],
          form_data = data.form_data,
          hasAdditionalInfo = false,
          additional_info_goods = [],
          additional_goodsid_arr = [],
          address_id = ''
        let usePickType = form_data.ecommerce_info.dispatch_use_pick_up_type
        let intraCityStatus = ''
        if (usePickType == 2) {
          intraCityStatus =
            form_data.ecommerce_info.ecommerce_transport_order &&
            form_data.ecommerce_info.ecommerce_transport_order.status
        }
        if (form_data.additional_info) {
          for (var i = 0; i < form_data.goods_info.length; i++) {
            var deliveryId = form_data.goods_info[i].delivery_id,
              goodsId = form_data.goods_info[i].goods_id
            if (
              deliveryId &&
              deliveryId != '0' &&
              additional_goodsid_arr.indexOf(goodsId) == -1
            ) {
              additional_info_goods.push(form_data.goods_info[i])
              additional_goodsid_arr.push(goodsId)
              hasAdditionalInfo = true
            }
          }
        }
        let remark = form_data.remark
        form_data.remark = remark ? remark.replace(/\n|\\n/g, '\n') : remark
        for (let i = 0; i < form_data.goods_info.length; i++) {
          if (form_data.goods_info[i].is_seckill == 1) {
            form_data.goods_info[i].downCount = {
              hours: '00',
              minutes: '00',
              seconds: '00'
            }
            if (form_data.goods_info[i].seckill_start_state == 0) {
              form_data.goods_info[i].downcount = app.beforeSeckillDownCount(
                form_data.goods_info[i],
                that,
                'orderInfo.goods_info[' + i + ']'
              )
            } else if (form_data.goods_info[i].seckill_start_state == 1) {
              form_data.goods_info[i].downcount = app.duringSeckillDownCount(
                form_data.goods_info[i],
                that,
                'orderInfo.goods_info[' + i + ']'
              )
            }
            form_data.goods_info[i] &&
              that.downcountArr.push(form_data.goods_info[i].downcount)
          }
        }
        if (form_data.refunded_price) {
          that.setData({
            hasAlreadyGoods: true
          })
        }
        if (form_data.pick_up_type == 2) {
          let sytime
          let nowTime = new Date().getTime()
          let addTime = form_data.add_time.replace(/\-/g, '/')
          let time = 15 * 60000 - (nowTime - new Date(addTime + '').getTime())
          if (time <= 0) {
            sytime = '0'
          } else {
            sytime = parseInt((time % (1000 * 60 * 60)) / (60 * 1000))
          }
          form_data.cacelOrderCountDownTime = sytime
        }
        if (form_data.wx_local_express_order) {
          let sameCity = true
          let showMap = true
          let orderStatus = form_data.status
          if ([3, 4, 5, 6, 7].find(item => item == orderStatus)) {
            showMap = false
          }
          that.initMapInfo(form_data, sameCity, showMap)
        }
        that.setData({
          orderInfo: form_data,
          vip_cut_price: form_data.vip_cut_price,
          is_vip_goods: form_data.goods_info[0].is_vip_goods,
          hasAdditionalInfo: hasAdditionalInfo,
          discount_cut_price: form_data.discount_cut_price,
          useBalance: form_data['use_balance'],
          express_fee: res.data[0]['express_fee'],
          box_fee: form_data['box_fee'] || 0,
          intraCityStatus: intraCityStatus || '',
          usePickType: usePickType
        })
        app.setPreviewGoodsInfo(additional_info_goods)
        app.setGoodsAdditionalInfo(form_data.additional_info || {})
        that.getRefundConfigByPickUpType(form_data.pick_up_type)
      }
    })
  }
  orderDelete = e => {
    let orderId = this.data.orderId
    let franchiseeId = this.franchiseeId
    let _this = this
    app.sendRequest({
      url: '/index.php?r=AppShop/HideOrder',
      data: {
        order_id: orderId,
        sub_shop_app_id: franchiseeId
      },
      success: function (res) {
        app.turnBack()
      },
      complete: function () {
        _this.setData({
          showEventDialog: false
        })
      }
    })
  }
  cancelOrder = e => {
    var orderId = this.data.orderInfo.order_id,
      that = this
    app.sendRequest({
      url: '/index.php?r=AppShop/cancelOrder',
      data: {
        order_id: orderId,
        sub_shop_app_id: that.franchiseeId
      },
      success: function (res) {
        var data = {}
        data['orderInfo.status'] = 7
        that.setData(data)
      },
      complete: function () {
        that.setData({
          showEventDialog: false
        })
      }
    })
  }
  payOrder = e => {
    var address_info = this.data.orderInfo.address_info,
      that = this,
      orderId = this.data.orderInfo.order_id
    if (this.data.orderInfo.total_price == 0) {
      app.sendRequest({
        url: '/index.php?r=AppShop/paygoods',
        data: {
          order_id: orderId,
          total_price: 0
        },
        success: function (res) {
          setTimeout(function () {
            app.showToast({
              title: '支付成功',
              icon: 'success',
              success: function () {
                that.paySuccessCallback()
              }
            })
          })
        }
      })
      return
    }
    // app.sendRequest({
    //   url: '/index.php?r=AppShop/GetWxWebappPaymentCode',
    //   data: {
    //     order_id: orderId
    //   },
    //   success: function (res) {
    //     var param = res.data
    //     param.orderId = orderId;
    //     param.goodsType = that.data.orderInfo.goods_type
    //     param.success = function () {
    //       that.paySuccessCallback()
    //     }
    //     app.wxPay(param)
    //   }
    // })
    let franchiseeId = that.franchiseeId;
    let pagePath = '/goodsOrderPaySuccess?detail=' + orderId + (franchiseeId ? '&franchisee=' + franchiseeId : '');

    app.goPay({
      orderId: orderId,
      successUrl: pagePath
    });
  }
  applyDrawback = () => {
    let orderId = this.data.orderId
    let franchiseeId = this.franchiseeId
    let pagePath =
      '/eCommerce/pages/previewGoodsRefund/previewGoodsRefund?orderId=' +
      orderId +
      (franchiseeId ? '&franchisee=' + franchiseeId : '')
    app.turnToPage(pagePath)
  }
  editorRefund = () => {
    let orderId = this.data.orderId
    let franchiseeId = this.franchiseeId
    let pagePath =
      '/eCommerce/pages/goodsRefundPage/goodsRefundPage?type=editor&orderId=' +
      orderId +
      (franchiseeId ? '&franchisee=' + franchiseeId : '')
    app.turnToPage(pagePath)
  }
  receiveDrawback = () => {
    var orderId = this.data.orderInfo.order_id,
      that = this
    app.sendRequest({
      url: '/index.php?r=AppShop/comfirmRefund',
      data: {
        order_id: orderId,
        sub_shop_app_id: that.franchiseeId
      },
      success: function (res) {
        var data = {}
        data['orderInfo.status'] = 7
        that.setData(data)
      },
      complete: function () {
        that.setData({
          showEventDialog: false
        })
      }
    })
  }
  checkLogistics = () => {
    let orderId = this.data.orderId
    let ecommerce_info = this.data.orderInfo.ecommerce_info
    let sameCity = this.data.sameCity ? 1 : 0
    let usePickType = this.data.usePickType
    if (usePickType == 2) {
      let intraCityData = ecommerce_info.intra_city_data
      let type = (intraCityData && intraCityData.deliver_type) || ''
      let arriveTime =
        (intraCityData && intraCityData.intra_city_appointment_arrive_time) ||
        ''
      app.turnToPage(
        '/eCommerce/pages/sameJourneyLogistic/sameJourneyLogistic?orderId=' +
        orderId +
        '&type=' +
        type +
        '&arriveTime=' +
        arriveTime +
        '&franchiseeId=' +
        this.franchiseeId +
        '&sameCity=' +
        sameCity
      )
    } else {
      app.turnToPage(
        '/eCommerce/pages/logisticsPage/logisticsPage?detail=' +
        orderId +
        '&franchiseeId=' +
        this.franchiseeId
      )
    }
  }
  sureReceipt = () => {
    var orderId = this.data.orderId,
      that = this,
      addTime = Date.now()
    app.sendRequest({
      url: '/index.php?r=AppShop/comfirmOrder',
      data: {
        order_id: orderId,
        sub_shop_app_id: that.franchiseeId
      },
      success: function (res) {
        app.turnToPage(
          '/eCommerce/pages/transactionSuccess/transactionSuccess?pageFrom=transation&orderId=' +
          orderId +
          '&franchiseeId=' +
          that.franchiseeId
        )
        app.sendRequest({
          hideLoading: true,
          url: '/index.php?r=appShop/getIntegralLog',
          data: { add_time: addTime },
          success: function (res) {
            if (res.status == 0) {
              res.data &&
                that.setData({
                  rewardPointObj: {
                    showModal: true,
                    count: res.data,
                    callback: ''
                  }
                })
            }
          }
        })
      },
      complete: function () {
        that.setData({
          showEventDialog: false
        })
      }
    })
  }
  makeComment = () => {
    var franchiseeId = this.franchiseeId,
      pagePath =
        '/eCommerce/pages/makeComment/makeComment?detail=' +
        this.data.orderInfo.order_id +
        (franchiseeId ? '&franchisee=' + franchiseeId : '')
    app.turnToPage(pagePath)
  }
  goToHomepage = () => {
    var router = app.getHomepageRouter()
    app.turnToPage('/pages/' + router + '/' + router, true)
  }
  getFreigtAdress = () => {
    var that = this
    app.sendRequest({
      url: '/index.php?r=AppShop/getAppShopLocationInfo',
      data: {
        app_id: app.getAppId(),
        sub_app_id: that.franchiseeId
      },
      success: function (res) {
        that.setData({
          freightAdress: res.data
        })
      }
    })
  }
  seeAdditionalInfo = () => {
    app.turnToPage(
      '/eCommerce/pages/goodsAdditionalInfo/goodsAdditionalInfo?from=goodsOrderDetail'
    )
  }
  paySuccessCallback = () => {
    let orderId = this.data.orderId
    let franchiseeId = this.franchiseeId
    let pagePath =
      '/eCommerce/pages/goodsOrderPaySuccess/goodsOrderPaySuccess?detail=' +
      orderId +
      (franchiseeId ? '&franchisee=' + franchiseeId : '')
    if (!franchiseeId) {
      app.sendRequest({
        url: '/index.php?r=AppMarketing/CheckAppCollectmeStatus',
        data: {
          order_id: orderId,
          sub_app_id: franchiseeId
        },
        success: function (res) {
          if (res.valid == 0) {
            pagePath += '&collectBenefit=1'
          }
          app.turnToPage(pagePath, 1)
        }
      })
    } else {
      app.turnToPage(pagePath, 1)
    }
  }
  copyOrderId = () => {
    let _this = this
    app.setClipboardData({
      data: _this.data.orderId,
      success: function (res) {
        app.showToast({
          title: '复制成功',
          icon: 'success'
        })
      }
    })
  }
  getWriteOffCodeBox = () => {
    let _this = this
    let orderId = this.data.orderId
    let franchiseeId = this.franchiseeId
    app.sendRequest({
      url: '/index.php?r=AppShop/GetOrderVerifyCode',
      data: {
        sub_shop_app_id: franchiseeId,
        order_id: orderId,
      },
      success: _this.setVerificationCodeData
    })
  }
  setVerificationCodeData = res => {
    let _this = this
    _this.setData({
      codeImgUrl: res.data.qrcode_url,
      codeNum: res.data.code,
      codeStatus: res.data.status,
      showWriteOffCodeBox: true
    })
    _this.connectSocket()
  }
  connectSocket = () => {
    var _this = this
    app.connectSocket({
      url: 'wss://xcx.zhichiwangluo.com', //testonly
      header: {
        'content-type': 'application/json'
      },
      method: 'GET'
    })
    app.onSocketOpen(function (res) {
      let data = {
        action: 'mark_client',
        user_token: app.globalData.userInfo.user_token,
        scenario_name: 'app_order_verify',
        session_key: app.globalData.sessionKey
      }
      app.sendSocketMessage({
        data: JSON.stringify(data)
      })
      _this.verifiTimeInterval = setInterval(function () {
        let data = {
          action: 'heartbeat',
          user_token: app.globalData.userInfo.user_token,
          scenario_name: 'app_order_verify',
          session_key: app.globalData.sessionKey
        }
        app.sendSocketMessage({
          data: JSON.stringify(data)
        })
      }, 30000)
    })
    app.onSocketMessage(function (res) {
      let data = JSON.parse(res.data)
      if (data.action == 'push_to_client') {
        let msg = JSON.parse(data.msg)
        if (msg.type == 'app_order_verify' && msg.status == 0) {
          _this.setData({
            codeStatus: 1
          })
          clearInterval(_this.verifiTimeInterval)
          app.closeSocket()
        }
      }
    })
  }
  hideWriteOffCodeBox = () => {
    var _this = this
    this.setData({
      showWriteOffCodeBox: false
    })
    clearInterval(_this.verifiTimeInterval)
    app.closeSocket()
  }
  hideEventDialog = () => {
    this.setData({
      showEventDialog: false
    })
  }
  showEventDialog = event => {
    this.setData({
      eventType: event.currentTarget.dataset.type,
      showEventDialog: true
    })
  }
  goOrderProgress = () => {
    let orderId = this.data.orderId
    let franchiseeId = this.franchiseeId
    let pagePath =
      '/eCommerce/pages/goodsOrderProgress/goodsOrderProgress?orderId=' +
      orderId +
      (franchiseeId ? '&franchisee=' + franchiseeId : '')
    app.turnToPage(pagePath)
  }
  returnInfor = () => {
    let orderId = this.data.orderId
    let franchiseeId = this.franchiseeId
    let pagePath =
      '/eCommerce/pages/goodsReturnInfor/goodsReturnInfor?orderId=' +
      orderId +
      (franchiseeId ? '&franchisee=' + franchiseeId : '')
    app.turnToPage(pagePath)
  }
  cancelRefund = () => {
    let _this = this
    let orderId = this.data.orderId
    let franchiseeId = this.franchiseeId
    app.sendRequest({
      url: '/index.php?r=appShop/cancelRefund',
      data: {
        order_id: orderId,
        sub_shop_app_id: franchiseeId
      },
      success: function () {
        _this.getOrderDetail(orderId)
      }
    })
  }
  getAppECStoreConfig = () => {
    app.getAppECStoreConfig(res => {
      this.setData({
        storeStyle: res.color_config
      })
    }, this.franchiseeId)
  }
  deliveryDrawback = () => {
    let _this = this
    let orderId = this.data.orderId
    let franchiseeId = this.franchiseeId
    app.sendRequest({
      url: '/index.php?r=AppShop/applyRefund',
      data: {
        order_id: orderId,
        sub_shop_app_id: franchiseeId
      },
      success: function (res) {
        _this.getOrderDetail(orderId)
      },
      complete: function () {
        _this.setData({
          showEventDialog: false
        })
      }
    })
  }
  goAlreadyGoodsPage = () => {
    let that = this;
    /**
     * WEBAPP: 与【已退商品】页面交互 start
     */
    let currentPage = app.getCurrentPage();
    currentPage.data = {
      orderInfo: {
        goods_info: that.data.orderInfo.goods_info,
        refunded_price: that.data.orderInfo.refunded_price,
      }
    }
    /**
     * WEBAPP: 与【已退商品】页面交互 end
     */
    let pagePath = '/eCommerce/pages/goodsAlreadyRefunded/goodsAlreadyRefunded'
    app.turnToPage(pagePath)
  }
  getLogistics = () => {
    let _this = this
    app.sendRequest({
      url: '/index.php?r=AppShop/expressFlow',
      data: {
        order_id: _this.data.orderId
      },
      success: function (res) {
        let info = res.data
        if (!info) {
          return
        }
        if (info.is_custom) {
          _this.setData({
            logisticsCustom: info.is_custom
          })
        } else {
          let logistics = info.Traces
          if (info.waybill_id) {
            info.path_item_list.map(item => {
              item.AcceptTime = item.action_time
              item.AcceptStation = item.action_msg
            })
            logistics = info.path_item_list
          }
          _this.setData({
            logistics: logistics
          })
        }
      }
    })
  }
  toGoodsAfterSaleDetail = event => {
    let orderId = this.data.orderId
    let franchiseeId = this.franchiseeId
    let applyId = this.data.orderInfo.refund_apply.id
    let router =
      '/eCommerce/pages/goodsAfterSaleDetail/goodsAfterSaleDetail?applyId=' +
      applyId +
      '&detail=' +
      orderId +
      '&franchisee=' +
      franchiseeId
    app.turnToPage(router)
  }
  goDeliveryNavigation = () => {
    app.openLocation({
      latitude: Number(this.data.orderInfo.self_delivery_info.latitude),
      longitude: Number(this.data.orderInfo.self_delivery_info.longitude),
      name: this.data.orderInfo.self_delivery_info.address
    })
  }
  sameJournyLogistic = () => {
    var orderId = this.data.orderId
    app.turnToPage(
      '/eCommerce/pages/sameJournyLogistic/sameJournyLogistic?detail=' + orderId
    )
  }
  getRefundConfigByPickUpType = type => {
    let _this = this
    app.sendRequest({
      url: '/index.php?r=AppEcommerce/getRefundConfigByPickUpType',
      data: {
        pick_up_type: type,
        sub_shop_app_id: _this.franchiseeId
      },
      success: function (res) {
        if (res.data && res.data.config_data) {
          let data = res.data.config_data
          _this.setData({
            refundAdress: data.address || '',
            isFullRefund: data.is_full_refund
          })
        }
      }
    })
  }
  initMapInfo = (form_data, sameCity, showMap) => {
    let sameCityInfo = form_data.wx_local_express_order
    let markers = []
    let senderItem = {
      id: 0,
      latitude: sameCityInfo['sender']['lat'],
      longitude: sameCityInfo['sender']['lng'],
      iconPath:
        'http://cdn.jisuapp.cn/static/webapp/images/xcx-goods/merchant-delivery.png',
      width: 47,
      height: 51
    }
    let ridersItem = {
      id: 1,
      latitude: sameCityInfo['agent'] ? +sameCityInfo['agent']['lat'] : 22.52,
      longitude: sameCityInfo['agent'] ? +sameCityInfo['agent']['lng'] : 113.93,
      iconPath:
        'http://develop.zhichiwangluo.com/zhichi_frontend/static/jisuapp_editor/images/rider.png',
      width: 38,
      height: 45
    }
    let receiverItem = {
      id: 2,
      latitude: sameCityInfo['receiver']['lat'],
      longitude: sameCityInfo['receiver']['lng'],
      iconPath:
        'http://cdn.jisuapp.cn/static/webapp/images/xcx-goods/merchant-delivery.png',
      width: 47,
      height: 51
    }
    markers = [senderItem, ridersItem, receiverItem]
    markers = this.transPosition(markers, sameCityInfo.order_status)
    this.setData({
      'mapOverlay.markers': markers,
      sameCityInfo,
      sameCity,
      showMap
    })
  }
  transStatus = status => {
    switch (+status) {
      case 101:
        return '待骑手接单'
      case 102:
        return '骑手赶往商家'
      case 103:
      case 203:
      case 303:
        return '商家取消订单'
      case 201:
      case 202:
        return '骑手取货中'
      case 204:
      case 205:
        return '骑手取消订单'
      case 301:
        return '骑手配送中'
      case 302:
        return '订单已完成'
      case 304:
      case 305:
        return '配送失败'
      case 401:
      case 501:
      case 502:
        return '订单结束，等待重新配送'
    }
  }
  transPosition = (mapOverlay, status) => {
    let transStatus = this.transStatus(status)
    let obj = {
      callout: {
        content: transStatus,
        bgColor: '#ffffff',
        display: 'ALWAYS',
        padding: 4,
        borderRadius: 5
      }
    }
    switch (transStatus) {
      case '待骑手接单':
      case '商家取消订单':
      case '订单已完成':
      case '订单结束，等待重新配送':
        Object.assign(mapOverlay[0], obj)
        mapOverlay.splice(1, 1)
        this.setData({
          'mapOverlay.latitude': mapOverlay[0]['latitude'] + 0.0005,
          'mapOverlay.longitude': mapOverlay[0]['longitude']
        })
        break
      case '骑手赶往商家':
      case '骑手取货中':
      case '骑手取消订单':
      case '骑手配送中':
      case '配送失败':
        Object.assign(mapOverlay[1], obj)
        this.setData({
          'mapOverlay.latitude': mapOverlay[1]['latitude'] + 0.0005,
          'mapOverlay.longitude': mapOverlay[1]['longitude']
        })
        break
    }
    return mapOverlay
  }
  callRider = () => {
    let phone = this.data.sameCityInfo.agent.phone[0]
    app.makePhoneCall(phone)
  }

  render() {
    const {
      showGetUserInfo,
      rewardPointObj,
      shareGiftsObj,
      collectGiftsObj,
      collectGetObj,
      isFromTemplateMsg,
      storeStyle,
      orderIcon,
      orderInfo,
      sameCity,
      sameCityStatus,
      sameCityInfo,
      orderStatus,
      refundIcon,
      refundStatus,
      refundAdress,
      logistics,
      logisticsCustom,
      usePickType,
      mapOverlay,
      showMap,
      appLogo,
      appName,
      sessionFrom,
      discount_cut_price,
      box_fee,
      express_fee,
      useBalance,
      hasAdditionalInfo,
      hasAlreadyGoods,
      intraCityStatus,
      isFullRefund,
      codeImgUrl,
      codeStatus,
      codeNum,
      showWriteOffCodeBox,
      eventType,
      showEventDialog
    } = this.state

    return (
      <div className="official-page goods-order-detail">
        <TopNav title="订单详情" />
        <div className="order-contain">
          {isFromTemplateMsg && (
            <div
              className="orderDetail-goto-homepage"
              onClick={this.goToHomepage}
            >
              返回首页
            </div>
          )}
          <div
            className="seller-shipped"
            style={convertLineStyleData('background:' + storeStyle.theme)}
          >
            {orderInfo.status != 4 ? (
              <div>
                <span
                  className={
                    'order-icon ico-moon icon-' + orderIcon[orderInfo.status]
                  }
                ></span>
                <span>
                  {orderInfo.pick_up_type != 1 && orderInfo.status == 8
                    ? '商家待接单'
                    : orderInfo.status == 2 && sameCity
                      ? sameCityStatus[sameCityInfo.order_status]
                      : orderStatus[orderInfo.status]}
                </span>
              </div>
            ) : (
                <div>
                  <span
                    className={
                      'order-icon ico-moon icon-' +
                      refundIcon[orderInfo.refund_apply.status]
                    }
                  ></span>
                  <span>
                    {orderInfo.is_pay_on_delivery == 1
                      ? '审核中'
                      : refundStatus[orderInfo.refund_apply.status]}
                  </span>
                </div>
              )}
          </div>
          {orderInfo.status == 0 && orderInfo.expire && (
            <div className="order-prompt">
              请在尽快完成付款，还剩
              <span style={convertLineStyleData('color:' + storeStyle.theme)}>
                {orderInfo.has_seckill == 1
                  ? orderInfo.close_order_time + '分'
                  : orderInfo.expire}
              </span>
              （超时按<span style={convertLineStyleData('color:' + storeStyle.theme)}>取消订单</span>
              处理）
            </div>
          )}
          {orderInfo.status == 1 && orderInfo.expire && (
            <div className="order-prompt">付款成功，请耐心等待商家发货</div>
          )}
          {orderInfo.status == 2 && !sameCity && orderInfo.pick_up_type != 2 && (
            <div className="order-prompt">
              商家已发货，距自动收货还剩
              <span style={convertLineStyleData('color:' + storeStyle.theme)}>
                {orderInfo.expire}
              </span>
            </div>
          )}
          {orderInfo.status == 4 && orderInfo.refund_apply.status == 0 && (
            <div className="order-prompt">
              你已成功发起退款申请，请耐心等待商家处理，还剩
              <span style={convertLineStyleData('color:' + storeStyle.theme)}>
                {orderInfo.refund_apply.expire}
              </span>
              （超时按
              <span style={convertLineStyleData('color:' + storeStyle.theme)}>
                {orderInfo.is_pay_on_delivery == 1
                  ? '拒绝取消订单'
                  : '拒绝退款'}
              </span>
              处理）
            </div>
          )}
          {orderInfo.status == 4 && orderInfo.refund_apply.status == 3 && (
            <div className="order-prompt">
              商家已同意退货退款申请，请及时退货，还剩
              <span style={convertLineStyleData('color:' + storeStyle.theme)}>
                {orderInfo.refund_apply.expire}
              </span>
              （超时按
              <span style={convertLineStyleData('color:' + storeStyle.theme)}>买家撤销退货</span>
              处理）
            </div>
          )}
          {orderInfo.status == 4 && orderInfo.refund_apply.status == 4 && (
            <div className="order-prompt">
              请耐心等待商家收货，收货完成后将会进行退款
            </div>
          )}
          {orderInfo.pick_up_type == 2 && orderInfo.status == 8 && (
            <div className="order-prompt">
              {orderInfo.cacelOrderCountDownTime + '分钟未接单，订单将自动取消'}
            </div>
          )}
          {orderInfo.pick_up_type == 2 &&
            (orderInfo.status == 1 || orderInfo.status == 2) && (
              <div className="order-prompt">
                预计送达时间：
                <span style={convertLineStyleData('color:' + storeStyle.theme)}>
                  {
                    orderInfo.ecommerce_info.intra_city_data
                      .intra_city_appointment_arrive_time
                  }
                </span>
              </div>
            )}
          {orderInfo.status == 4 &&
            orderInfo.refund_apply.refund_type == 2 &&
            orderInfo.is_pay_on_delivery != 1 && (
              <React.Fragment>
                <div className="refund-address-box">
                  <div className="refund-address-title">
                    <span>退货地址</span>
                    <span className="pull-right">
                      {refundAdress.brand_name + ' ' + refundAdress.phone}
                    </span>
                  </div>
                  <div className="pull-right refund-address">
                    {refundAdress.region_info[2].name +
                      refundAdress.region_info[1].name +
                      refundAdress.region_info[0].name +
                      refundAdress.detail_address}
                  </div>
                </div>
              </React.Fragment>
            )}
          {(orderInfo.status == 2 ||
            orderInfo.status == 3 ||
            orderInfo.status == 5) &&
            usePickType == 1 && (
              <div onClick={this.checkLogistics}>
                <div className="goods-logistics">
                  <span className="ico-moon icon-goods-logistics"></span>
                  {logistics && logistics.length ? (
                    <div className="goods-logistics-info">
                      <div
                        className="goods-logistics-title"
                        style={convertLineStyleData('color:' + storeStyle.theme)}
                      >
                        {logistics[0].AcceptStation}
                      </div>
                      <div className="goods-logistics-time">
                        {logistics[0].AcceptTime}
                      </div>
                    </div>
                  ) : (
                      <div className="goods-logistics-info">
                        {logisticsCustom == 1 ? '商家自主发货' : '暂无物流信息'}
                      </div>
                    )}
                  <span
                    style={convertLineStyleData('display: inline-block;vertical-align: middle;')}
                    className="colord2d2 ico-moon icon-rightarrow"
                  ></span>
                </div>
              </div>
            )}
          {orderInfo.status != 4 && (
            <React.Fragment>
              <div className="buyer-information self-delivery-info">
                <span className="ico-moon icon-goods-location"></span>
                {orderInfo.pick_up_type == 1 && (
                  <React.Fragment>
                    <div className="buyer-box">
                      <div className="buyer-name-box">
                        <span
                          className="cash-delivery shipping-type"
                          style={convertLineStyleData('background:' + storeStyle.theme)}
                        >
                          快递
                        </span>
                        {orderInfo.is_pay_on_delivery == 1 && (
                          <span
                            className="cash-delivery"
                            style={convertLineStyleData('background:' + storeStyle.theme)}
                          >
                            到付
                          </span>
                        )}
                        <span className="buyer-name">
                          {orderInfo.address_info.name}
                        </span>
                        <span>{orderInfo.address_info.contact}</span>
                      </div>
                      <div className="buyer-address">
                        {orderInfo.address_info.province.text +
                          orderInfo.address_info.city.text +
                          orderInfo.address_info.district.text +
                          orderInfo.address_info.detailAddress}
                      </div>
                    </div>
                  </React.Fragment>
                )}
                {orderInfo.pick_up_type == 2 ? (
                  <React.Fragment>
                    <div className="buyer-box">
                      <div className="buyer-name-box">
                        <span
                          className="cash-delivery shipping-type"
                          style={convertLineStyleData('background:' + storeStyle.theme)}
                        >
                          同城
                        </span>
                        {orderInfo.is_pay_on_delivery == 1 && (
                          <span
                            className="cash-delivery"
                            style={convertLineStyleData('background:' + storeStyle.theme)}
                          >
                            到付
                          </span>
                        )}
                        <span className="buyer-name">
                          {orderInfo.address_info.name}
                        </span>
                        <span>{orderInfo.address_info.contact}</span>
                      </div>
                      <div className="buyer-address">
                        {orderInfo.address_info.province.text +
                          orderInfo.address_info.city.text +
                          orderInfo.address_info.district.text +
                          orderInfo.address_info.detailAddress}
                      </div>
                    </div>
                  </React.Fragment>
                ) : (
                    orderInfo.pick_up_type == 3 && (
                      <React.Fragment>
                        <div className="buyer-box">
                          <div className="buyer-name-box">
                            <span
                              className="cash-delivery shipping-type"
                              style={convertLineStyleData('background:' + storeStyle.theme)}
                            >
                              自提
                          </span>
                            {orderInfo.is_pay_on_delivery == 1 && (
                              <span
                                className="cash-delivery"
                                style={convertLineStyleData('background:' + storeStyle.theme)}
                              >
                                到付
                            </span>
                            )}
                            <span className="buyer-name">
                              {orderInfo.self_delivery_info.contact_name}
                            </span>
                            <span>
                              {orderInfo.self_delivery_info.contact_phone}
                            </span>
                          </div>
                          <div className="buyer-address">
                            {orderInfo.self_delivery_info.address}
                          </div>
                        </div>
                        <div
                          className="delivery-navigation"
                          style={convertLineStyleData('color:' + storeStyle.theme)}
                          onClick={this.goDeliveryNavigation}
                        >
                          导航
                      </div>
                      </React.Fragment>
                    )
                  )}
              </div>
            </React.Fragment>
          )}
          {sameCity && showMap && (
            <div className="same-city-map">
              <Map
                latitude={mapOverlay.latitude}
                longitude={mapOverlay.longitude}
                markers={mapOverlay.markers}
                enableRotate
                scale="17"
              ></Map>
              {sameCityInfo.agent.phone && (
                <div className="rider-box">
                  <div>
                    <img
                      className="rider-logo"
                      src="http://develop.zhichiwangluo.com/zhichi_frontend/static/jisuapp_editor/images/rider-ico.png"
                    />
                    <span className="rider-name">
                      {sameCityInfo.agent.name}
                    </span>
                  </div>
                  <div className="rider-contact" onClick={this.callRider}>
                    <span>联系骑手</span>
                    <div className="phone-box">
                      <span className="ico-moon icon-takeout-cellphone-left"></span>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
          <div className="app-box">
            <div>
              <img className="app-logo" src={appLogo} />
              <span className="app-name">{appName}</span>
              <div className="contact-service pull-right">
                <span>联系客服</span>
                <span className="ico-moon icon-goods-customer-service"></span>
                {/* TODO */}
                {/* <button openType="contact" sessionFrom={sessionFrom}></button> */}
                <button></button>
              </div>
            </div>
          </div>
          {orderInfo && orderInfo.goods_info && orderInfo.goods_info.map((goods, goodsIndex) => {
            return (
              <React.Fragment key={goodsIndex}>
                {goods.is_seckill == 1 && (
                  <div className="seckill-time">
                    <div
                      className="countdown"
                      style={convertLineStyleData('color:' + storeStyle.theme)}
                    >
                      {goods.seckill_start_state == 0 ? (
                        <label>距开始</label>
                      ) : goods.seckill_start_state == 1 ? (
                        <label>距结束还剩</label>
                      ) : (
                            goods.seckill_start_state == 2 && <label>已结束</label>
                          )}
                      {!!goods.downCount.days && (
                        <span className="days">
                          {goods.downCount.days + '天'}
                        </span>
                      )}
                      <span
                        className="hours countdown-text"
                        style={convertLineStyleData('background-color:' + storeStyle.theme)}
                      >
                        {goods.downCount.hours}
                      </span>
                      :
                      <span
                        className="minutes countdown-text"
                        style={convertLineStyleData('background-color:' + storeStyle.theme)}
                      >
                        {goods.downCount.minutes}
                      </span>
                      :
                      <span
                        className="seconds countdown-text"
                        style={convertLineStyleData('background-color:' + storeStyle.theme)}
                      >
                        {goods.downCount.seconds}
                      </span>
                    </div>
                  </div>
                )}
                <div className="goods-detail-box">
                  <img src={goods.cover} />
                  <div>
                    <div className="goods-name">
                      {orderInfo.is_group_buy_order != 0 && (
                        <span className="is-seckill">拼团</span>
                      )}
                      {goods.is_presell == 1 && (
                        <span className="is-seckill">预售</span>
                      )}
                      {goods.is_seckill == 1 && (
                        <span className="is-seckill">秒杀</span>
                      )}
                      {goods.is_vip_goods == 1 && (
                        <span className="is-seckill">会员价</span>
                      )}
                      {goods.is_benefit_goods == 1 && (
                        <span className="is-seckill">赠品</span>
                      )}
                      {goods.goods_name}
                    </div>
                    {goods.model_value && (
                      <div className="goods-rules">{goods.model_value}</div>
                    )}
                    <div className="goods-price">
                      {!goods.use_integral || goods.use_integral == 0 ? (
                        <React.Fragment>
                          <span
                            className="colorff7"
                            style={convertLineStyleData('color:' + storeStyle.theme)}
                          >
                            {'¥' + goods.price}
                          </span>
                        </React.Fragment>
                      ) : (
                          <React.Fragment>
                            {goods.price != '0.00' && (
                              <span
                                className="colorff7"
                                style={convertLineStyleData('color:' + storeStyle.theme)}
                              >
                                {'¥' + goods.price}
                              </span>
                            )}
                            {goods.max_can_use_integral &&
                              goods.max_can_use_integral != '0' &&
                              goods.max_can_use_integral != 0 &&
                              goods.price != '0.00' && (
                                <span
                                  className="colorff7"
                                  style={convertLineStyleData('color:' + storeStyle.theme)}
                                >
                                  +
                              </span>
                              )}
                            {goods.max_can_use_integral &&
                              goods.max_can_use_integral != '0' &&
                              goods.max_can_use_integral != 0 && (
                                <span
                                  className="colorff7"
                                  style={convertLineStyleData('color:' + storeStyle.theme)}
                                >
                                  {goods.max_can_use_integral + '积分'}
                                </span>
                              )}
                          </React.Fragment>
                        )}
                      <span className="pull-right">{'x ' + goods.num}</span>
                    </div>
                  </div>
                </div>
              </React.Fragment>
            )
          })}
          {orderInfo.status == 4 && orderInfo.refund_apply.id && (
            <div className="refunding-btn-box">
              <span
                className="refunding-btn"
                onClick={this.toGoodsAfterSaleDetail}
              >
                退款中
              </span>
            </div>
          )}
          <div className="goods-amount">
            <span>商品金额</span>
            <span className="pull-right color999">
              {'¥' +
                (orderInfo.is_vip_order == 1
                  ? orderInfo.total_original_price
                  : orderInfo.original_price)}
            </span>
          </div>
          {orderInfo.has_seckill == 1 && (
            <div className="spike-offer">
              <span>活动优惠</span>
              <span className="pull-right color999">
                {'秒杀  - ¥' + orderInfo.seckill_cut_price}
              </span>
            </div>
          )}
          {orderInfo.selected_benefit_info && (
            <div className="promotion-method">
              <div>
                <span>优惠方式</span>
                <span className="pull-right promotion-method-title color999">
                  {orderInfo.selected_benefit_info.title || '无'}
                </span>
              </div>
              <div className="pull-right color999">
                {'- ¥' + discount_cut_price}
              </div>
            </div>
          )}
          {orderInfo && orderInfo.extra_selected_benefit_info && orderInfo.extra_selected_benefit_info.title && (
            <div className="promotion-method">
              <div>
                <span>联盟优惠</span>
                <span className="pull-right promotion-method-title color999">
                  {orderInfo.extra_selected_benefit_info.title || '无'}
                </span>
              </div>
              <div className="pull-right color999">
                {'- ¥' + orderInfo.extra_discount_cut_price}
              </div>
            </div>
          )}
          {orderInfo.is_vip_order == 1 && orderInfo.vip_cut_price != '0.00' && (
            <div className="promotion-method">
              <span>会员价优惠</span>
              <span className="pull-right promotion-method-title color999">
                {'- ¥' + orderInfo.vip_cut_price}
              </span>
            </div>
          )}
          {box_fee > 0 && (usePickType == 2 || usePickType == 4) && (
            <div className="freight box-fee">
              <span>包装费</span>
              <span className="pull-right color999">{'￥ ' + box_fee}</span>
            </div>
          )}
          <div className="freight">
            <span>{orderInfo.pick_up_type == 2 ? '配送费' : '运费'}</span>
            <span className="pull-right color999">{'¥' + express_fee}</span>
          </div>
          <div className="total-order-price">
            <span>订单总价</span>
            <span className="pull-right color999">
              {'¥' + orderInfo.order_total_price}
            </span>
          </div>
          {useBalance > 0 && (
            <div className="stored-value-deduction">
              <span>储值抵扣</span>
              <span className="pull-right color999">{'- ¥' + useBalance}</span>
            </div>
          )}
          {orderInfo.coupon_fee && (
            <div>
              社交立减金
              <span className="pull-right">{'- ¥' + orderInfo.coupon_fee}</span>
            </div>
          )}
          <div className="actual-payment">
            <div>
              <span>实际付款</span>
              <span
                className="pull-right colorff7"
                style={convertLineStyleData('color:' + storeStyle.theme)}
              >
                {'¥' + orderInfo.total_price}
              </span>
            </div>
          </div>
          {orderInfo.remark && (
            <div className="buyer-message">
              <span>买家留言</span>
              <span className="pull-right">{orderInfo.remark}</span>
            </div>
          )}
          {hasAdditionalInfo && (
            <div className="addition-info" onClick={this.seeAdditionalInfo}>
              <div>
                <span>补充信息</span>
                <span className="pull-right colord2d2 ico-moon icon-rightarrow"></span>
              </div>
            </div>
          )}
          <div
            className="addition-info no-border"
            onClick={this.goOrderProgress}
          >
            <div>
              <span>订单进度</span>
              <span className="pull-right colord2d2 ico-moon icon-rightarrow"></span>
            </div>
          </div>
          {hasAlreadyGoods && (
            <div
              className="addition-info no-border already-refund-goods"
              onClick={this.goAlreadyGoodsPage}
            >
              <div>
                <span>已退商品</span>
                <span className="pull-right colord2d2 ico-moon icon-rightarrow"></span>
              </div>
            </div>
          )}
          <div className="order-number">
            {orderInfo.pick_up_type == 3 ? (
              <div>
                <span style={convertLineStyleData('margin-right:54rpx;')}>流水号</span>
                <span>
                  {orderInfo.ecommerce_info.ec_tostore_data.formatted_queue_num}
                </span>
              </div>
            ) : (
                orderInfo.pick_up_type == 2 && (
                  <div>
                    <span style={convertLineStyleData('margin-right:80rpx;')}>编号</span>
                    <span>
                      {orderInfo.ecommerce_info.intra_city_data.serial_number}
                    </span>
                  </div>
                )
              )}
            <div>
              <span>订单编号</span>
              <span>{orderInfo.order_id}</span>
              <span className="pull-right" onClick={this.copyOrderId}>
                复制
              </span>
            </div>
            <div>
              <span>下单时间</span>
              <span>{orderInfo.add_time}</span>
            </div>
            {orderInfo.pick_up_type == 2 && (
              <div>
                <div>
                  <span>预定时间</span>
                  <span>
                    {
                      orderInfo.ecommerce_info.intra_city_data
                        .intra_city_appointment_arrive_time
                    }
                  </span>
                </div>
                {orderInfo.wx_local_express_order && orderInfo.wx_local_express_order.add_resp.pickup_code && (
                  <div>
                    <span style={convertLineStyleData('display:inline-block;width:96rpx')}>取货码</span>
                    <span>
                      {orderInfo.wx_local_express_order.add_resp.pickup_code}
                    </span>
                  </div>
                )}
              </div>
            )}
            {orderInfo.pick_up_type == 3 && (
              <React.Fragment>
                {orderInfo.ecommerce_info.ec_tostore_data
                  .ec_tostore_appointment_time && (
                    <div>
                      <span>预约时间</span>
                      <span>
                        {
                          orderInfo.ecommerce_info.ec_tostore_data
                            .ec_tostore_appointment_time
                        }
                      </span>
                    </div>
                  )}
                {orderInfo.ecommerce_info.ec_tostore_data
                  .ec_tostore_location_name && (
                    <div>
                      <span>店内位置</span>
                      <span>
                        {
                          orderInfo.ecommerce_info.ec_tostore_data
                            .ec_tostore_location_name
                        }
                      </span>
                    </div>
                  )}
                {orderInfo.ecommerce_info.ec_tostore_data
                  .ec_tostore_buyer_phone && (
                    <div>
                      <span>手机号码</span>
                      <span>
                        {
                          orderInfo.ecommerce_info.ec_tostore_data
                            .ec_tostore_buyer_phone
                        }
                      </span>
                    </div>
                  )}
              </React.Fragment>
            )}
          </div>
          <div className="order-bottom">
            {orderInfo.status == 0 && (
              <React.Fragment>
                <span
                  className="apply-refund"
                  onClick={this.showEventDialog}
                  data-type="cancelOrder"
                >
                  取消订单
                </span>
                <span
                  className="btn btn-orange orderDetail-pay-directly"
                  style={convertLineStyleData(
                    'color:' +
                    storeStyle.theme +
                    ';border-color:' +
                    storeStyle.theme
                  )}
                  onClick={this.payOrder}
                >
                  立即支付
                </span>
              </React.Fragment>
            )}
            {orderInfo.status == 1 && (
              <React.Fragment>
                <span
                  className="btn btn-orange"
                  style={convertLineStyleData(
                    'color:' +
                    storeStyle.theme +
                    ';border-color:' +
                    storeStyle.theme
                  )}
                  onClick={this.getWriteOffCodeBox}
                >
                  核销码
                </span>
                {intraCityStatus > 1 &&
                  intraCityStatus != 5 &&
                  intraCityStatus != 1000 && (
                    <span className="btn" onClick={this.checkLogistics}>
                      配送信息
                    </span>
                  )}
                {orderInfo.is_pay_on_delivery == 1 ? (
                  <span
                    className="apply-refund"
                    onClick={this.showEventDialog}
                    data-type="deliveryDrawback"
                  >
                    取消订单
                  </span>
                ) : (
                    ((orderInfo.is_group_buy_order != 0 &&
                      orderInfo.can_refund_order == 1) ||
                      orderInfo.is_group_buy_order == 0) &&
                    isFullRefund == 1 && (
                      <span className="apply-refund" onClick={this.applyDrawback}>
                        申请退款
                    </span>
                    )
                  )}
              </React.Fragment>
            )}
            {orderInfo.status == 2 && (
              <React.Fragment>
                {orderInfo.pick_up_type != 3 && (
                  <span className="btn" onClick={this.checkLogistics}>
                    配送信息
                  </span>
                )}
                {orderInfo.is_pay_on_delivery == 1 ? (
                  <span
                    className="apply-refund"
                    onClick={this.showEventDialog}
                    data-type="deliveryDrawback"
                  >
                    取消订单
                  </span>
                ) : (
                    ((orderInfo.is_group_buy_order != 0 &&
                      orderInfo.can_refund_order == 1) ||
                      orderInfo.is_group_buy_order == 0) &&
                    isFullRefund == 1 && (
                      <span className="apply-refund" onClick={this.applyDrawback}>
                        申请退款
                    </span>
                    )
                  )}
                <span
                  className="btn btn-orange"
                  style={convertLineStyleData(
                    'color:' +
                    storeStyle.theme +
                    ';border-color:' +
                    storeStyle.theme
                  )}
                  onClick={this.getWriteOffCodeBox}
                >
                  核销码
                </span>
                <span
                  className="btn btn-orange"
                  style={convertLineStyleData(
                    'color:' +
                    storeStyle.theme +
                    ';border-color:' +
                    storeStyle.theme
                  )}
                  onClick={this.showEventDialog}
                  data-type="sureReceipt"
                >
                  确认收货
                </span>
              </React.Fragment>
            )}
            {orderInfo.status == 3 && (
              <React.Fragment>
                <span
                  className="apply-refund"
                  onClick={this.showEventDialog}
                  data-type="orderDelete"
                >
                  删除订单
                </span>
                <span
                  className="btn btn-orange"
                  style={convertLineStyleData(
                    'color:' +
                    storeStyle.theme +
                    ';border-color:' +
                    storeStyle.theme
                  )}
                  onClick={this.getWriteOffCodeBox}
                >
                  核销码
                </span>
                <span
                  className="btn btn-orange"
                  style={convertLineStyleData(
                    'color:' +
                    storeStyle.theme +
                    ';border-color:' +
                    storeStyle.theme
                  )}
                  onClick={this.makeComment}
                >
                  去评价
                </span>
              </React.Fragment>
            )}
            {orderInfo.status == 4 && (
              <React.Fragment>
                <span className="btn" onClick={this.cancelRefund}>
                  {orderInfo.refund_apply.status == 3 ||
                    orderInfo.refund_apply.status == 4
                    ? '撤销退货'
                    : '撤销申请'}
                </span>
                {orderInfo.is_pay_on_delivery != 1 && (
                  <span className="btn" onClick={this.editorRefund}>
                    修改申请
                  </span>
                )}
                {orderInfo.refund_apply.status == 3 && (
                  <span
                    className="btn btn-orange"
                    style={convertLineStyleData(
                      'color:' +
                      storeStyle.theme +
                      ';border-color:' +
                      storeStyle.theme
                    )}
                    onClick={this.returnInfor}
                  >
                    填写退货信息
                  </span>
                )}
              </React.Fragment>
            )}
            {orderInfo.status == 5 && (
              <React.Fragment>
                <span
                  className="btn"
                  onClick={this.showEventDialog}
                  data-type="receiveDrawback"
                >
                  收到退款
                </span>
              </React.Fragment>
            )}
            {orderInfo.status == 6 && (
              <React.Fragment>
                <span
                  className="apply-refund"
                  onClick={this.showEventDialog}
                  data-type="orderDelete"
                >
                  删除订单
                </span>
              </React.Fragment>
            )}
            {orderInfo.status == 7 && (
              <React.Fragment>
                <span
                  className="apply-refund"
                  onClick={this.showEventDialog}
                  data-type="orderDelete"
                >
                  删除订单
                </span>
              </React.Fragment>
            )}
            {orderInfo.status == 8 && (
              <React.Fragment>
                <span
                  className="apply-refund"
                  onClick={this.showEventDialog}
                  data-type="cancelOrder"
                >
                  取消订单
                </span>
              </React.Fragment>
            )}
          </div>
        </div>
        {showWriteOffCodeBox && (
          <div
            className="verification-code"
            onClick={this.hideWriteOffCodeBox}
          >
            <div className="verification-code-tips">
              向商家出示二维码或核销码后即可消费
            </div>
            <div className="verification-image-box">
              <img className="verification-code-img" src={codeImgUrl} />
              {codeStatus == 1 && (
                <div className="verification-code-finished">
                  <div>已核销</div>
                </div>
              )}
            </div>
            <div className="verification-code-text">
              <span>核销码：</span>
              <span>{codeNum}</span>
            </div>
          </div>
        )}
        {showEventDialog && (
          <div className="event-dialog-mask">
            <div className="event-dialog">
              {eventType == 'cancelOrder' && (
                <div className="event-dialog-title">确认取消订单？</div>
              )}
              {eventType == 'orderDelete' && (
                <div className="event-dialog-title">
                  订单删除后不可找回，确认删除？
                </div>
              )}
              {eventType == 'receiveDrawback' && (
                <div className="event-dialog-title">确定已收到退款？</div>
              )}
              {eventType == 'sureReceipt' && (
                <div className="event-dialog-title">
                  确认收货代表您已经拿到货物，确认后将无法撤销！建议与商家联系后再操作
                </div>
              )}
              {eventType == 'deliveryDrawback' && (
                <div className="event-dialog-title">确认取消订单？</div>
              )}
              <div className="event-dialog-bottom">
                <span className="event-cancel" onClick={this.hideEventDialog}>
                  取消
                </span>
                {eventType == 'cancelOrder' && (
                  <span
                    style={convertLineStyleData('color:' + storeStyle.theme)}
                    className="event-sure"
                    onClick={this.cancelOrder}
                  >
                    确认
                  </span>
                )}
                {eventType == 'orderDelete' && (
                  <span
                    style={convertLineStyleData('color:' + storeStyle.theme)}
                    className="event-sure"
                    onClick={this.orderDelete}
                  >
                    确认
                  </span>
                )}
                {eventType == 'receiveDrawback' && (
                  <span
                    style={convertLineStyleData('color:' + storeStyle.theme)}
                    className="event-sure"
                    onClick={this.receiveDrawback}
                  >
                    确认
                  </span>
                )}
                {eventType == 'sureReceipt' && (
                  <span
                    style={convertLineStyleData('color:' + storeStyle.theme)}
                    className="event-sure"
                    onClick={this.sureReceipt}
                  >
                    确认
                  </span>
                )}
                {eventType == 'deliveryDrawback' && (
                  <span
                    style={convertLineStyleData('color:' + storeStyle.theme)}
                    className="event-sure"
                    onClick={this.deliveryDrawback}
                  >
                    确认
                  </span>
                )}
              </div>
            </div>
          </div>
        )}
     </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/goods-order-detail/GoodsOrderDetail.jsx